/* eslint-disable react/jsx-no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { getMenuLink } from "@lib/utils"
import loadable from "@loadable/component"
import clsx from "clsx"
import { Link } from "gatsby"
import React from "react"
import getVideoId from "get-video-id"
import VideoModal from "./PlayVideo/VideoModal"

const CTALink = ({ onClick, className, cta, children, label }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [vidUrl, setVidUrl] = React.useState("")
   
  if (!cta) return null

  // console.log("cta =>", cta)

  const { cta_label, custom_link, menu, isExternal } = cta

  let linkHref = null

  linkHref = menu && getMenuLink(menu)

  if (custom_link) {
    if (isExternal) {
      linkHref = { href: custom_link }
    } else {
      linkHref = { to: custom_link }
    }
  }

  const videoid = custom_link && getVideoId(custom_link)

  const handlePopupVid = (videoUrl) => {
    setVidUrl(videoUrl)
    setIsOpen(true)
  }

  if (!(linkHref?.to || linkHref?.href || custom_link)) return null

  // if (!linkHref) {
  //   linkHref = { href: "javascript:;" }
  // }

  const Comp = custom_link?.includes("tel:") ? "a" : Link

  if (Comp === "a" && linkHref?.to) {
    linkHref.href = linkHref?.to
  }

  // console.log("cta=>", cta)

  // if (!custom_link && lowerCase(cta.cta_label).indexOf("valuation") > -1) {
  {/*if (
    linkHref?.to?.includes("$popup-valuation") ||
    linkHref.href?.includes("$popup-valuation")
  ) {
    // dynamically import the module to code split the bundle
    const ReapitValuation = loadable(
      () => import("@components/ReapitValuation/ReapitValuation"),
    )

    return (
      <ReapitValuation className={className} type='["sales", "lettings"]'>
        {cta_label || label}
      </ReapitValuation>
    )
  }*/}

  if (
    linkHref.to?.includes("$popup-valuation") ||
    linkHref.href?.includes("$popup-valuation")
  ) {
    // dynamically import the module to code split the bundle
    const ValuationModalWithTrigger = loadable(() =>
      import("@components/PopupForms/ValuationModal").then(
        (module) => module.ValuationModalWithTrigger,
      ),
    )

    return (
      process.env.GATSBY_FORMS_ENABLE === "true" && (
        <ValuationModalWithTrigger
          cta_label={cta_label || label}
          className={className}
        />
      )
    )
  }

  if (
    linkHref.to?.includes("$popup-requestcall-form") ||
    linkHref.href?.includes("$popup-requestcall-form")
  ) {
    // dynamically import the module to code split the bundle
    const RequestCallbackModalWithTrigger = loadable(() =>
      import("@components/PopupForms/RequestCallbackModal").then(
        (module) => module.RequestCallbackModalWithTrigger,
      ),
    )

    return (
      process.env.GATSBY_FORMS_ENABLE === "true" && (
        <RequestCallbackModalWithTrigger
          cta_label={cta_label || label}
          className={className}
        />
      )
    )
  } 

  if (
    linkHref.to?.includes("$popup-sendcv-form") ||
    linkHref.href?.includes("$popup-sendcv-form")
  ) {
    // dynamically import the module to code split the bundle
    const SendCVModalWithTrigger = loadable(() =>
      import("@components/PopupForms/SendCVModal").then(
        (module) => module.SendCVModalWithTrigger,
      ),
    )

    return (
      process.env.GATSBY_FORMS_ENABLE === "true" && (
        <SendCVModalWithTrigger cta_label={cta_label} className={className} />
      )
    )
  }

  if (
    linkHref.to?.includes("$popup-request-repair") ||
    linkHref.href?.includes("$popup-request-repair")
  ) {
    // dynamically import the module to code split the bundle
    const ReportRepairModalWithTrigger = loadable(() =>
      import("@components/PopupForms/ReportRepairModal").then(
        (module) => module.ReportRepairModalWithTrigger,
      ),
    )

    return (
      process.env.GATSBY_FORMS_ENABLE === "true" && (
        <ReportRepairModalWithTrigger className={className} />
      )
    )
  }

  if (
    linkHref.to?.includes("$RSVP_modal") ||
    linkHref.href?.includes("$RSVP_modal")
  ) {
    // dynamically import the module to code split the bundle
    const RSVPModalWithTrigger = loadable(() =>
      import("@components/PopupForms/RSVPModal").then(
        (module) => module.RSVPModalWithTrigger,
      ),
    )

    return (
      process.env.GATSBY_FORMS_ENABLE === "true" && (
        <RSVPModalWithTrigger className={className} buttonText={cta_label} />
      )
    )
  }

  // console.log("videoid", videoid)

  return (
    <>
      {videoid?.id ? (
        <a
          // eslint-disable-next-line no-script-url
          href="javascript:;"
          className={clsx(className)}
          onClick={() => handlePopupVid(custom_link)}
        >
          {children || <span>{cta_label || label}</span>}
        </a>
      ) : (
        <Comp
          className={clsx(className)}
          onClick={() => {
            if (onClick) {
              onClick()
            }
          }}
          // to="/"
          {...linkHref}
          {...((!!isExternal || !!custom_link?.includes("http")) && {
            target: "_blank",
          })}
        >
          {children || <span>{cta_label || label}</span>}
        </Comp>
      )}

      {isOpen && (
        <VideoModal isOpen={isOpen} setIsOpen={setIsOpen} videoUrl={vidUrl} />
      )}
    </>
  )
}

export default CTALink
